import React from 'react';
import ContactUsContent from '../components/home/homePart4'
import Bottom from '../components/bottom'
import '../assets/css/contactus.css'

const Service: React.FC = () => {
    return (
        <div className='contactus_main_box'>
            <div className="content_main">
                <ContactUsContent />
            </div>
            <div className="content_bottom">
                <Bottom />
            </div>
        </div>
    )

};

export default Service;
